import { render, staticRenderFns } from "./SpliceReportsTable.vue?vue&type=template&id=0b004340&scoped=true"
import script from "./SpliceReportsTable.vue?vue&type=script&lang=js"
export * from "./SpliceReportsTable.vue?vue&type=script&lang=js"
import style0 from "./SpliceReportsTable.vue?vue&type=style&index=0&id=0b004340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b004340",
  null
  
)

export default component.exports